import { useState } from 'react';
import LscTouchpointsData from './LscTouchpointsData';

const useLscTouchpointData = () => {
  const [ lscTouchpointState, setLscTouchpointState ] = useState(LscTouchpointsData.INITIAL_STATE);

  const postLscTouchpoint = (orgUnitId, touchpointObj) => {
    return LscTouchpointsData.postLscTouchpointData(orgUnitId, touchpointObj, lscTouchpointState, setLscTouchpointState);
  };

  const putLscTouchpoint = (lscTouchpointId, touchpointObj) => {
    return LscTouchpointsData.putLscTouchpointData(lscTouchpointId, touchpointObj, lscTouchpointState, setLscTouchpointState);
  };

  const deleteLscTouchpoint = (lscTouchpointId) => {
    return LscTouchpointsData.deleteLscTouchpointData(lscTouchpointId, lscTouchpointState, setLscTouchpointState);
  };

  return {
    lscTouchpointState,
    postLscTouchpoint,
    putLscTouchpoint,
    deleteLscTouchpoint
  }
}

export default useLscTouchpointData;


